import { isArray } from "lodash"
import React, { Dispatch, SetStateAction } from "react"
import { RouteProps } from "react-router"
import { allPages } from "../../constant/pages"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjGridFilter from "@grapecity/wijmo.grid.filter"
import {
  stringErrorMessage,
  JsonSchemeRequiredErrorMessages,
} from "./erromessages"
import { T区分マスタ } from "../../components/ComboBox/KubunComboBox"
import { 区分分類コード } from "../../constant/enum/codes"
import { ErrorObject } from "ajv"

import {
  copyObject,
  // DataChangeEventArgs,
} from "@grapecity/wijmo.grid.immutable"
import constants from "../../constant/constant"
import dayjs from "dayjs"
import Decimal from "decimal.js"
import { e消費税計算区分, T消費税計算区分 } from "../../constant/enum/master"
import { T表紙分割 } from "../../components/ComboBox/HyosiBunkatuComboBox"

/**
 * 他言語のstring.format
 * @param string {0}等が変換対象
 * @param args 置換文字
 * @returns
 */
export const stringFormat = (string: string, ...args: (string | number)[]) =>
  string.replace(/{(\d+)}/g, (match, number) => {
    return typeof args[number] != "undefined" ? `${args[number]}` : match
  })

export const stringArrayToComponent = (stringList: Array<string>) => (
  <>
    {stringList
      .filter((m) => (m ?? false) && m !== "")
      .map((m, i, a) => {
        return i < a.length - 1 ? (
          <React.Fragment key={i}>
            {m}
            <br />
          </React.Fragment>
        ) : (
          <React.Fragment key={i}>{m}</React.Fragment>
        )
      })}
  </>
)
export const stringArrayToListComponent = (stringList: Array<string>) => (
  <ul>
    {stringList
      .filter((m) => (m ?? false) && m !== "")
      .map((m, i, a) => {
        return <li key={i}>{m}</li>
      })}
  </ul>
)

//ページ先頭へのスクロール関数
export const goToPageTop = () => {
  const element = document.getElementById("rootContainer")
  element?.scrollTo({ top: 0 })
}

/**
 * RoutePropsからPathの先頭を取得する
 * @param RouteProps
 * @returns string
 */
export const getDefaultPath = (
  RouteProps: RouteProps,
  defaultPath?: string
): string => {
  if (RouteProps.path instanceof Array && RouteProps.path.length > 0) {
    return RouteProps.path[0]
  } else if (typeof RouteProps.path === "string") {
    return RouteProps.path
  }
  return defaultPath ?? ""
}

// blob to base64
export const blobToBase64 = (blob: Blob) =>
  new Promise<string | ArrayBuffer | null>((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.onload = () => resolve(fileReader.result)
    fileReader.onerror = (error) => reject(error)
    fileReader.readAsDataURL(blob)
  })
export const base64ToBlob = (base64String: string) => fetch(base64String)

/**
 * 分類コードとメニューコードよりpathListを取得
 * @param メニューコード
 * @param 分類コード
 * @returns
 */
const getMenuPath: (
  //TODO:マージ後戻す
  メニューコード: string,
  // Tメニューコード,
  分類コード?: string
  // T分類コード
) => string[] = (メニューコード: string, 分類コード?: string) => {
  const path = allPages.find(
    (page) =>
      page.メニューコード === メニューコード &&
      (分類コード != null ? page.分類コード === 分類コード : true)
  )?.Route.path
  if (path == null) return [""]
  if (isArray(path)) {
    if (path.length > 0) {
      return path
    } else {
      return [""]
    }
  } else {
    return [path]
  }
}

/**
 * グリッド上で荷主コードに連動したdataMapを作る際の補助メソッドです
 * メソッド終了後適宜flexgridをrefreshしてください
 * @template TGridRowItem 対象gridの列定義
 * @template TDataItem データマップを入れる対象の型定義
 * @param {(wjcGrid.FlexGrid | undefined)} flexGrid 対象grid
 * @param {TDataItem[]} dataList データマップに入れる配列
 * @param {keyof TGridRowItem} columnBinding データマップを設定する列のbinding
 * @param {keyof TDataItem} selectedValuePath データマップの選択値
 * @param {keyof TDataItem} displayMemberPath データマップの表示値
 * @param {(value:wjcGrid.DataMap | undefined) => unknown} setDataMap データマップを格納する関数
 * @param {(
 *     value: TDataItem,
 *     index: number,
 *     array: TDataItem[]
 *   ) => string} displayNameFunc datamapの表示値を設定するメソッド
 */
const set表紙分割DataMapFrom荷主コードChanged = <
  TGridRowItem extends { 荷主コード: string },
  TDataItem extends T表紙分割
>(
  flexGrid: wjcGrid.FlexGrid | undefined,
  dataList: TDataItem[],
  columnBinding: keyof TGridRowItem,
  selectedValuePath: keyof TDataItem,
  displayMemberPath: keyof TDataItem,
  setDataMap: (value: wjcGrid.DataMap | undefined) => unknown,
  displayNameFunc: (
    value: TDataItem,
    index: number,
    array: TDataItem[]
  ) => string
) => {
  // setするためのdataMapをnewする
  const dataMap = new wjcGrid.DataMap(
    dataList,
    selectedValuePath.toString(),
    displayMemberPath.toString()
  )

  // set対象の列を取得
  const column = flexGrid?.getColumn(columnBinding.toString())

  if (column) {
    column.dataMap = dataMap
    // 画面に表示するプロパティを設定するメソッド
    dataMap.getDisplayValues = (dataItem: TGridRowItem) => {
      let filteredSource = dataList.filter(
        (h) => h.荷主コード === dataItem.荷主コード && h.廃止日 == null
      )
      return filteredSource.map(displayNameFunc)
    }
    // 作成したdataMapを操作 stateに入れるなど
    setDataMap(dataMap)

    column.dataMapEditor = wjcGrid.DataMapEditor.DropDownList
  }
}

/**
 * グリッド上で荷主コードに連動したdataMapを作る際の補助メソッドです
 * メソッド終了後適宜flexgridをrefreshしてください
 * @template TGridRowItem 対象gridの列定義
 * @template TDataItem データマップを入れる対象の型定義
 * @param {(wjcGrid.FlexGrid | undefined)} flexGrid 対象grid
 * @param {TDataItem[]} dataList データマップに入れる配列
 * @param {keyof TGridRowItem} columnBinding データマップを設定する列のbinding
 * @param {keyof TDataItem} selectedValuePath データマップの選択値
 * @param {keyof TDataItem} displayMemberPath データマップの表示値
 * @param {(value:wjcGrid.DataMap | undefined) => unknown} setDataMap データマップを格納する関数
 * @param {(
 *     value: TDataItem,
 *     index: number,
 *     array: TDataItem[]
 *   ) => string} displayNameFunc datamapの表示値を設定するメソッド
 */
const setDataMapFrom荷主コードChanged = <
  TGridRowItem extends { 荷主コード: string },
  TDataItem extends { 荷主コード: string }
>(
  flexGrid: wjcGrid.FlexGrid | undefined,
  dataList: TDataItem[],
  columnBinding: keyof TGridRowItem,
  selectedValuePath: keyof TDataItem,
  displayMemberPath: keyof TDataItem,
  setDataMap: (value: wjcGrid.DataMap | undefined) => unknown,
  displayNameFunc: (
    value: TDataItem,
    index: number,
    array: TDataItem[]
  ) => string
) => {
  // setするためのdataMapをnewする
  const dataMap = new wjcGrid.DataMap(
    dataList,
    selectedValuePath.toString(),
    displayMemberPath.toString()
  )

  // set対象の列を取得
  const column = flexGrid?.getColumn(columnBinding.toString())

  if (column) {
    column.dataMap = dataMap
    // 画面に表示するプロパティを設定するメソッド
    dataMap.getDisplayValues = (dataItem: TGridRowItem) => {
      let filteredSource = dataList.filter(
        (h) => h.荷主コード === dataItem.荷主コード
      )
      return filteredSource.map(displayNameFunc)
    }
    // 作成したdataMapを操作 stateに入れるなど
    setDataMap(dataMap)

    column.dataMapEditor = wjcGrid.DataMapEditor.DropDownList
  }
}

/**
 * グリッド上で荷主コードに連動したdataMapを作る際の補助メソッドです
 * メソッド終了後適宜flexgridをrefreshしてください
 * @template TGridRowItem 対象gridの列定義
 * @template TDataItem データマップを入れる対象の型定義
 * @param {(wjcGrid.FlexGrid | undefined)} flexGrid 対象grid
 * @param {TDataItem[]} dataList データマップに入れる配列
 * @param {keyof TGridRowItem} columnBinding データマップを設定する列のbinding
 * @param {keyof TDataItem} selectedValuePath データマップの選択値
 * @param {keyof TDataItem} displayMemberPath データマップの表示値
 * @param {(value:wjcGrid.DataMap | undefined) => unknown} setDataMap データマップを格納する関数
 * @param {(
 *     value: TDataItem,
 *     index: number,
 *     array: TDataItem[]
 *   ) => string} displayNameFunc datamapの表示値を設定するメソッド
 */
const setDataMapFrom荷主請求Changed = <
  TGridRowItem extends { 荷主請求ID?: number },
  TDataItem extends { 荷主請求ID: number }
>(
  flexGrid: wjcGrid.FlexGrid | undefined,
  dataList: TDataItem[],
  columnBinding: keyof TGridRowItem,
  selectedValuePath: keyof TDataItem,
  displayMemberPath: keyof TDataItem,
  setDataMap: (value: wjcGrid.DataMap | undefined) => unknown,
  displayNameFunc: (
    value: TDataItem,
    index: number,
    array: TDataItem[]
  ) => string
) => {
  // setするためのdataMapをnewする
  const dataMap = new wjcGrid.DataMap(
    dataList,
    selectedValuePath.toString(),
    displayMemberPath.toString()
  )

  // set対象の列を取得
  const column = flexGrid?.getColumn(columnBinding.toString())

  if (column) {
    // 画面に表示するプロパティを設定するメソッド
    dataMap.getDisplayValues = (dataItem: TGridRowItem) => {
      let filteredSource = dataList.filter(
        (h) => h.荷主請求ID === dataItem.荷主請求ID
      )
      return filteredSource.map(displayNameFunc)
    }
    // 作成したdataMapを操作 stateに入れるなど
    setDataMap(dataMap)
    column.dataMap = dataMap
    column.dataMapEditor = wjcGrid.DataMapEditor.DropDownList
  }
}

/**
 * コンボボックスの基本的なテキストフォーマッター
 * @param item
 * @param valueField 選択値プロパティ
 * @param displayField 表示テキストプロパティ
 * @returns
 */
export const defaultComboBoxTextFormatter = <TItem extends {}>(
  item: TItem,
  valueField: keyof TItem,
  displayField: keyof TItem
) => {
  const value = item[valueField] != null ? item[valueField] : ""
  const valueText = value as string
  return `${valueText}${valueText === "" ? "" : "："} ${item[displayField]}`
}

/**
 * コンボボックスの基本的なテキストフォーマッター
 * @param item
 * @param valueField 選択値プロパティ
 * @param displayField 表示テキストプロパティ
 * @returns
 */
export const comboBoxIDFormatter = <TItem extends {}>(
  item: TItem,
  valueField: keyof TItem,
  displayField: keyof TItem
) => {
  const value = item[valueField] != null ? item[valueField] : 0
  const valueText = value as number
  return `${valueText === 0 ? "" : `${valueText}：`} ${item[displayField]}`
}

/**
 * 値と名称の逆転したEnumを返却します
 * 値と名称が全て一意の場合のみ使用できます
 * @param enumObject
 * @param value
 * @returns
 */
export const getReverseEnum = <
  T extends {
    [name: string]: string | number
  }
>(
  enumObject: T
) => {
  const keys: (keyof T)[] = Object.keys(enumObject)
  let newEnum: { [name in string | number]: keyof T } = {}
  keys.forEach((key) => {
    const value = enumObject[key]
    newEnum[value] = key
  })
  return newEnum
}

/**
 * 食事手当の金額から区分コードを返却します
 * @param 区分ItemSource
 * @param 食事手当料
 * @returns
 */
export const get食事手当コード = (
  区分ItemSource: T区分マスタ[] | undefined,
  食事手当料: number | undefined
) => {
  // 食事手当をコードに変換して設定する。
  if (区分ItemSource && 区分ItemSource?.length > 0) {
    const 食事区分List = 区分ItemSource.filter(
      (i) => i.分類コード === 区分分類コード.マスタ.食事手当区分
    )
    return 食事区分List.find((d) => d.数値1 === 食事手当料)?.区分コード
  }
}

/**
 * Symbol使わないでユニークな値生成
 */
export const getUniqueStr = (myStrong?: number): string => {
  let strong = 1000
  if (myStrong) strong = myStrong
  return (
    new Date().getTime().toString(16) +
    Math.floor(strong * Math.random()).toString(16)
  )
}

/**
 * エラー発生時の項目色変え用メソッド
 * @param errors ajvより出力されたvalidate.errors
 * @param targetItems [setIsInvalidState, state対象となる項目名]となるタプルを格納した配列
 */
export const setValidateError = (
  errors: ErrorObject<string, Record<string, any>, unknown>[],
  targetItems: [Dispatch<SetStateAction<boolean>>, string][]
) => {
  const instancePaths = errors.map((e) => e.instancePath.replaceAll("/", ""))
  const requiredProperties = errors
    .filter(
      (e) =>
        e.instancePath === "" &&
        e.params.errors != null &&
        e.params.errors.length > 0 &&
        e.params.errors.find(
          (ec: { keyword: string }) => ec.keyword === "required"
        )
    )
    .map((e) => {
      const error = e.params.errors[0]
      return error.params.missingProperty
    })
  const errorProperties = [...instancePaths, ...requiredProperties]

  targetItems.forEach((targetItem) => {
    targetItem[0](errorProperties.includes(targetItem[1]))
  })
}

const addRowId = <T, G extends T & { row_id?: string }>(dataList: T[]): G[] => {
  //  uniqueIDをセットする為、リストをループして設定
  let newItemList: G[] = []
  dataList.forEach((d) => {
    let newItem = Object.freeze(
      copyObject({}, { ...d, row_id: getUniqueStr() })
    )
    newItemList.push(newItem)
  })

  return newItemList
}

/**
 * delimiterを前方に付与しながら文字列を結合します
 * 空文字やnull の場合空白は付与されません
 * @param orgText
 * @param text
 * @returns
 */
const addTextWithStartDelimiter = (
  orgText: string,
  text?: (string | null | undefined)[] | string | null,
  delimiter = " " //基本は空白
): string => {
  if (text instanceof Array) {
    return (
      text.reduce(
        (org, addText) =>
          addTextWithStartDelimiter(org ?? "", addText, delimiter),
        orgText
      ) ?? ""
    )
  } else {
    let returnText = ""
    if (orgText !== "") {
      if (text == null || text === "") {
        returnText = orgText
      } else {
        returnText = `${orgText}${delimiter}${text}`
      }
    } else {
      returnText = `${text ?? ""}`
    }
    return returnText
  }
}

/**
 * targetに対してlength分の0埋めしたsort用文字列を返却します。
 * 空の場合はlength分を9埋めした文字列を返却します。
 * @param target
 * @param length
 * @returns
 */
const createSortString = (
  target: string | null | undefined,
  length: number
): string => {
  return target != null && target !== ""
    ? target?.padStart(length, "0")
    : "".padStart(length, "9")
}

// デフォルトのフィルター時の文字列整形関数
const defaultValueFieldCustomizedFunc = (
  filter: wjGridFilter.FlexGridFilter,
  grid: wjcGrid.FlexGrid
) => {
  const colBindings = grid.columns
    .filter((c) => c.binding != null)
    .map((c) => c.binding as string)
  colBindings.forEach((colBinding) => {
    const ColumnFilter = filter?.getColumnFilter(colBinding)
    if (!ColumnFilter) return
    const valueFilter = ColumnFilter.valueFilter
    const uniqueValues: { value: any; text: string }[] =
      valueFilter.getUniqueValues()

    // データマップ用の配列を作成
    let dataMapSource = uniqueValues.map((uniqueValue) => {
      // 時間系のカラムの場合表示を YYYY/MM/DDに変更する
      if (
        uniqueValue.value &&
        constants.ISO8601_DATE_REGEX.test(uniqueValue.value.toString())
      ) {
        return {
          value: uniqueValue.value,
          text: dayjs(uniqueValue.value).format("YYYY/MM/DD"),
        }
      }

      return { ...uniqueValue }
    })

    ColumnFilter.dataMap = new wjcGrid.DataMap(dataMapSource, "value", "text")
  })
}

/**
 * 車番を0埋めの4桁の文字列に変更
 * @param data
 * @returns
 */
const createPadding車番 = (data: string | null | undefined) =>
  createSortString(data, 4)

/**
 *
 * @param 税込価格
 * @param 消費税率
 * @returns
 */
const get消費税抜額 = (
  税込価格: number,
  消費税率: number,
  消費税計算区分?: T消費税計算区分
): number => {
  const 税抜 = new Decimal(税込価格).times(100).div(100 + 消費税率)
  switch (消費税計算区分) {
    case e消費税計算区分.切り上げ:
      return 税抜.ceil().toNumber()
    case e消費税計算区分.切り捨て:
      return 税抜.trunc().toNumber()
    case e消費税計算区分.四捨五入:
    default:
      return 税抜.round().toNumber()
  }
}

const commonUtil = {
  stringErrorMessage,
  JsonSchemeRequiredErrorMessages,
  stringFormat,
  goToPageTop,
  getDefaultPath,
  blobToBase64,
  base64ToBlob,
  getMenuPath,
  set表紙分割DataMapFrom荷主コードChanged,
  setDataMapFrom荷主コードChanged,
  setDataMapFrom荷主請求Changed,
  getReverseEnum,
  get食事手当コード,
  getUniqueStr,
  setValidateError,
  addRowId,
  addTextWithStartDelimiter,
  createSortString,
  defaultValueFieldCustomizedFunc,
  createPadding車番,
  get消費税抜額,
}

export default commonUtil
